import Input, { DashboardCheckbox, DashboardSelect } from "../../components/Input/Input"
import { SelectChangeEvent } from '@mui/material'
import * as Sentry from "@sentry/react";
import React, { useEffect, useState } from 'react'
import ConfigurationHeader from "../../components/heading/ConfigurationHeader"
import QuestionHeading from "../../components/heading/QuestionHeading"
import { convertValuesToConfig, createValidation, doFinalConfigSubmit, getMetaDataConfig, getNewConfiguration, postConfiguration, updateConfiguration } from "../../services/uiConfigService"
import { openPopup } from "../../stateManagement/actions/popupActions"
import { validateWithOtp } from "../../stateManagement/actions/validateOtpPopupActions"
import { manageUpdateAccessObj } from "../manageUpdateAccess/manageUpdateAccessTypes"
import { IndentWrapper } from "../orderConfiguration/OrderConfiguration"
import { configurationAttributeType, sfaConfigurationValuesTypes } from "../../types"
import { deepClone } from "@mui/x-data-grid/utils/utils"
import { initialSfaValues } from "../defaultConfigurations/sfaConfigurationDefaultValues"
import "./SFAConfigurations.css"
import * as yup from 'yup'


const SFAConfigurations=()=>{
    const [sfaConfig, setSfaConfig] = useState<configurationAttributeType[]>([]);
    const [values, setValues] = useState<sfaConfigurationValuesTypes>(deepClone(initialSfaValues))
    const [sfaValidationsSchema, setSfaValidationSchema] = useState({})


    useEffect(() => {
        const getSfaConfiguration = async () => {
            try {

                const resp = await getNewConfiguration("sfa_configurations");
                const sfa_config: configurationAttributeType[] = resp?.domainValues;
                setSfaConfig([...sfa_config])
            } catch (err) {
                // Sentry.captureException(err);
            }
        }
        getSfaConfiguration();
    }, [])

    const handleCheckChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const keyName = e.target.name;
        setValues((prevValues) => ({
            ...prevValues,
            [keyName]: {
                ...prevValues[keyName],
                value: values.forceUpdateConfig.value[0].showForceUpdate, 
                isValueUpdated: true
            },
            forceUpdateConfig: keyName === 'forceUpdateEnabled' ? {
                ...prevValues.forceUpdateConfig,
                value: [{
                    ...prevValues.forceUpdateConfig.value[0],
                    showForceUpdate: !values.forceUpdateConfig.value[0].showForceUpdate 
                }]
            } : prevValues.forceUpdateConfig
        }));
    
    };
    
    

    const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const keyName = e.target.name;
        setValues({
            ...values,
            [keyName]: {...values[keyName], value:e.target.value, isValueUpdated:true} 
        })
    }

    const handleSelectValueChange = (e: SelectChangeEvent<unknown>) => {
        const keyName = e.target.name;
        setValues({
            ...values,
            [keyName]: {...values[keyName], value:e.target.value, isValueUpdated:true} 
        })
    }

    const handleAppVersionChange = (e: React.ChangeEvent<HTMLInputElement>) => {

        const keyName = e.target.name;
        const newValues = {
            ...values,
            forceUpdateConfig: {
                ...values.forceUpdateConfig,
                value: [{ ...values.forceUpdateConfig.value[0], [keyName]: e?.target.value}]
            }
        }
        setValues(newValues)
    }

    const saveConfiguration= async(preview?:boolean)=>{
            try{
                const configName="sfa_configurations"
                const sfaSchema=yup.object({...sfaValidationsSchema})
                const validationObject:any = {};
                Object.keys(values).forEach(key=>{
                    validationObject[key] = values[key].value;
                })
                // await sfaSchema.validate(validationObject)
                const convertedVals = convertValuesToConfig(values, sfaConfig);
                await doFinalConfigSubmit(configName,convertedVals);
                } catch(err){
                // Sentry.captureException(err);
                console.log("err===", err)
                if (err instanceof Error)
                openPopup('Error',"Validation Error occured : " + err?.message)
            }
    }

    const setSfaConfigValues = () => {
        try {

            if (sfaConfig.length) {
                const temp = { ...values };
                const result = { ...initialSfaValues } as { [key: string]: unknown }
                const resValidations = {} as { [key: string]: ReturnType<typeof createValidation> }
                sfaConfig.forEach((attr) => {
                    resValidations[attr.name] = createValidation(attr)
                    result[attr.name] = attr;
                })
                setValues({ ...result as sfaConfigurationValuesTypes });
                setSfaValidationSchema({ ...resValidations })
            }
        } catch (err) {
            // Sentry.captureException(err);
        }
    }
    useEffect(() => {
        setSfaConfigValues();
    }, [sfaConfig])

    return (
        <div className="sfa_config_container">
         <ConfigurationHeader heading={"SFA Configuration"} saveConfiguration={() => saveConfiguration(false)} createPreview={() => saveConfiguration(true)} />
            <div className="sfa_form_container">
                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        Enter the Store in Range.
                    </QuestionHeading>
                    <div className="answer_container">
                          <Input name="storeInRange" value={values.storeInRange.value} onChange={handleValueChange}  />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    Enter the loader Failure Text.
                    </QuestionHeading>
                    <div className="  answer_container">
                    <Input name="loaderFailedText" value={values.loaderFailedText.value} onChange={handleValueChange} />

                    </div>
                    </IndentWrapper>

                    <IndentWrapper indent={0}>
                        <QuestionHeading>
                            Enter the PJP Label text
                        </QuestionHeading>
                        <div className="answer_container">
                        <DashboardSelect onChange={handleSelectValueChange} value={values.pjpLabel.value} name="pjpLabel" options={values.pjpLabel.possibleVals} selectLableId='pjpLabel' />

                        </div>
                    </IndentWrapper> 


                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        Select the Additional Message
                    </QuestionHeading>
                    <div className="answer_container">
                    <Input name="additionalMessage" value={values.additionalMessage.value} onChange={handleValueChange} />
                    </div>
                </IndentWrapper>


                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        Show configuration to force update on screen as soon as the user opens the app (Select to enable)
                    </QuestionHeading>
                    <div className="answer_container">
                     <DashboardCheckbox onChange={handleCheckChange} checked={values.forceUpdateConfig?.value[0]?.showForceUpdate}  name="forceUpdateEnabled" label="Enable Force Update" />
                    </div>
                </IndentWrapper>

                {values.forceUpdateConfig.value[0].showForceUpdate && (
                <>
                <IndentWrapper indent={2}>
                    <QuestionHeading>
                        Android App Version
                    </QuestionHeading>
                    <div className="answer_container">
                     <Input name="latestAndroidVersion" value={values.forceUpdateConfig?.value[0]?.latestAndroidVersion} onChange={handleAppVersionChange} />

                    </div>
                </IndentWrapper>
                <IndentWrapper indent={2}>
                    <QuestionHeading>
                        IoS App Version 
                    </QuestionHeading>
                    <div className="answer_container">
                     <Input name="latestIosVersion" value={values.forceUpdateConfig?.value[0]?.latestIosVersion} onChange={handleAppVersionChange} />
                    </div>
                </IndentWrapper>
                </>
                )}
            </div>
        </div>
    )
}
export default SFAConfigurations